{
  "26 JULY STREET": "STRASSE AM 26. JULI",
  "A lunar research city under glass, with silver habitat towers, observatories and rover avenues nestled inside a vast terraced crater.": "Eine Mondforschungsstadt unter Glas mit silbernen Habitattürmen, Observatorien und Roveralleen inmitten eines riesigen terrassenförmigen Kraters.",
  "A palm-lined boulevard, spectacular resorts, and the lights of Downtown.": "Ein palmengesäumter Boulevard, spektakuläre Resorts und die Lichter der Innenstadt.",
  "ABDEL KHALEQ": "ABDEL KHALEQ",
  "ABDİ İPEKÇİ": "ABDİPEKÇİ",
  "ACCADEMIA": "ACCADEMIA",
  "ACIDALIA": "ACIDALIA",
  "ADLY STREET": "SCHLECHTE STRASSE",
  "AFRICA AVENUE": "AFRICA AVENUE",
  "AGULHAS RIDGE": "AGULHAS-BRÜCKE",
  "AKARSU": "AKARSU",
  "AKBAR ROAD": "AKBAR-STRASSE",
  "AKIHABARA": "AKIHABARA",
  "AL AHARAM": "AL SAHARAM",
  "AL AZHAR": "AL AZHAR",
  "AL AZHAR PARK": "AL AZHAR PARK",
  "AL FALAKI": "AL FALAKI",
  "AL MUIZZ": "ALLE MUIZZ",
  "ALAMEDA": "ALAMEDA",
  "ALAMEDA SANTOS": "ALAMEDA SANTOS",
  "ALBA MONS": "ALBA MONS",
  "ALEMDAR": "ALEMDAR",
  "ALTSTADT · MAXVORSTADT · ISAR": "ALTSTADT · MAXVORSTADT · ISAR",
  "AMAZONIS": "AMAZONIS",
  "AMEYOKO": "AMEYOKO",
  "ANKARA CADDESİ": "ANKARA CADDESI",
  "AOYAMA DORI": "AOYAMA DORI",
  "APGUJEONG RO": "PAGUJEONG ODER",
  "ARBAT": "ARBAT",
  "ARCADIA": "ARKADIEN",
  "ARCHIMEDES": "ARCHIMEDES",
  "ARGYRE PLANITIA": "ARGYRE PLANITIA",
  "ARISTARCHUS": "ARISTARCHOS",
  "ARISTOTELES": "ARISTOTELES",
  "ARSIA MONS": "MARSIA — MÖNCHE",
  "ASAKUSA · MARUNOUCHI · SHINJUKU": "ASAKUSA · MARUNOUCHI · SHINJUKU",
  "ASCRAEUS MONS": "ASKRAEUS MONS",
  "ASHOKA ROAD": "ASHOKA-STRASSE",
  "ATLANTIC SEABED · OCEANA": "ATLANTISCHER MEERESBODEN · OZEANIEN",
  "AVENIDA BERRINI": "AVENIDA BERRINI",
  "AVENIDA FARIA LIMA": "AVENIDA FARIA LIMA",
  "AVENIDA IPIRANGA": "AVENIDA IPIRANGA",
  "AVENIDA PAULISTA": "AVENIDA PAULISTA",
  "AVENIDA REBOUÇAS": "AVENIDA REBOUCAS",
  "AVENIDA SÃO JOÃO": "AVENIDA SÃO JOÃO",
  "AVENUE DE L’OPÉRA": "AVENUE DE L'OPÉRA",
  "AVENUE DE SÉGUR": "AVENUE DE SÉGUR",
  "AVENUE FOCH": "AVENUE FOCH",
  "AVENUE KLEBER": "ALLEE KLEBER",
  "AVENUE MONTAIGNE": "AVENUE MONTAIGNE",
  "AVENUE VICTOR HUGO": "ALLEE VICTOR HUGO",
  "AVINGUDA DIAGONAL": "AVINGUDA DIAGONAL",
  "AZORES": "AZOREN",
  "Across Manhattan, over the East River, down to the harbor.": "Quer durch Manhattan, über den East River, runter zum Hafen.",
  "Along the Grand Canal, past marble arcades, terracotta roofs and gondolas drifting beneath bridges.": "Entlang des Canal Grande, vorbei an Marmorarkaden, Terrakottadächern und Gondeln, die unter Brücken hindurchtreiben.",
  "Along the Seine, through limestone boulevards, and up to the domes of Montmartre.": "Entlang der Seine, durch Kalksteinboulevards und hinauf zu den Kuppeln von Montmartre.",
  "Altstadt": "Historischer Stadtkern",
  "An imagined Atlantic city beneath glass: pearl towers, bronze colonnades and stepped palaces between blue canals where dolphins, sharks and whales swim.": "Eine imaginäre Atlantikstadt unter Glas: Perlentürme, Bronzekolonnaden und Treppenpaläste zwischen blauen Kanälen, in denen Delfine, Haie und Wale schwimmen.",
  "Arc de Triomf": "Arc de Triomf",
  "Arc de Triomphe": "Triumphbogen",
  "Ares Landing Port": "Ares Landehafen",
  "Asakusa": "Asakusa",
  "Avenida Paulista": "Avenida Paulista",
  "BAB AL FUTUH": "BAB AL FUTUH",
  "BABA KHARAK SINGH": "BABA KHARAK SINGH",
  "BACINO SAN MARCO": "BACINO SAN MARCO",
  "BAHARİYE": "BAHARIYE",
  "BANKALAR": "BANKALAR",
  "BARAKHAMBA ROAD": "BARAKHAMBA-STRASSE",
  "BAY OF BISCAY": "GOLF VON BISKAYA",
  "BAĞDAT CADDESİ": "BAĞDAT CADDESI",
  "BERMUDA RISE": "AUFSTIEG DER BERMUDAS",
  "BIENVENIDOS": "BIENVENIDOS",
  "BIENVENUE": "BIENVENUE",
  "BLAKE PLATEAU": "BLAKE-PLATEAU",
  "BOLSHAYA NIKITSKAYA": "BOLSHAYA NIKITSKAYA",
  "BONANZA RD": "BONANZA ROAD",
  "BOULEVARD HAUSSMANN": "BOULEVARD HAUSSMANN",
  "BRAZIL STREET": "BRASILIANISCHE STRASSE",
  "BRIENNER STRASSE": "BRIENNER STRASSE",
  "BROADWAY": "BROADWAY",
  "BROOKLYN": "BROOKLYN",
  "BUFFALO DR": "BÜFFEL, DR.",
  "BUKCHON RO": "BUKCHON ODER",
  "Ba Đình": "Ba Đình",
  "Bahapur": "Bahapur",
  "Bellas Artes Palace": "Palacio de Bellas Artes",
  "Beyoğlu": "Beyoglu",
  "Beşiktaş": "Beşiktaş",
  "Biosphere district": "Biosphärenbezirk",
  "Blue Mosque": "Blaue Moschee",
  "Bolshoi Theatre": "Bolschoi-Theater",
  "Bosphorus": "Bosporus",
  "Bosque de Chapultepec": "Bosque de Chapultepec",
  "Broadway House": "Broadway-Haus",
  "Brooklyn Crossing": "Brooklyn-Kreuzung",
  "Bundaran HI": "Bundaran, HI",
  "CAFERİYE": "CAFERİYE",
  "CAMPO MANIN": "CAMPO MANIN",
  "CAMPO SAN POLO": "CAMPO SAN POLO",
  "CAMPO SANTA MARGHERITA": "CAMPO SANTA MARGHERITA",
  "CAMPO SANTO STEFANO": "CAMPO SANTO STEFANO",
  "CANAL GRANDE": "CANAL GRANDE",
  "CANAL PORT": "KANALHAFEN",
  "CANARY BASIN": "KANARISCHES BECKEN",
  "CANNAREGIO": "CANNAREGIO",
  "CAPE BASIN": "KAPBECKEN",
  "CAPE VERDE": "KAP VERDE",
  "CARNIVAL": "KARNEVAL",
  "CARRER ARAGÓ": "CARRER ARAGÓ",
  "CARRER AVINYÓ": "CARRER AVINYÓ",
  "CARRER FERRAN": "CARRER FERRAN",
  "CARRER MALLORCA": "CARRER MALLORCA",
  "CARRER PRINCESA": "CARRER PRINCESA",
  "CARRER PROVENÇA": "CARRER PROVENÇA",
  "CARRER ROSSELLÓ": "CARRER ROSSELLÓ",
  "CARRER VALÈNCIA": "CARRER VALÈNCIA",
  "CARRER VERDI": "CARRER VERDI",
  "CARSON AVE": "CARSON AVE",
  "CENTENARIO": "HUNDERTJAHRFEIER",
  "CENTRAL DELHI · MEHRAULI · NIZAMUDDIN": "ZENTRAL-DELHI · MEHRAULI · NIZAMUDDIN",
  "CHAMPOLLION": "CHAMPOLLION",
  "CHAMPS-ÉLYSÉES": "CHAMPS-ELYSÉES",
  "CHANDNI CHOWK": "CHANDNI CHOWK",
  "CHANG’AN AVE": "CHANG'AN-HÖHLE",
  "CHAOYANGMEN": "CHAOYANGMEN",
  "CHAPULTEPEC": "CHAPULTEPEC",
  "CHARLESTON BLVD": "CHARLESTON BOULEVARD",
  "CHARLIE GIBBS": "CHARLIE GIBBS",
  "CHELSEA": "CHELSEA",
  "CHEONGGYECHON RO": "CHEONGGYECHON ODER",
  "CHISTOPRUDNY BLVD": "CHISTOPRUDNY BOULEVARD",
  "CHRYSE": "CHRYSE",
  "CITIC Tower": "CITIC-Turm",
  "CITY FESTIVAL": "STADTFEST",
  "CITY PARK": "STADTPARK",
  "CITY TAX": "STADTSTEUER",
  "CIUTADELLA": "CIUTADELLA",
  "CLAVIUS": "CLAVIUS",
  "CLAVIUS CRATER · LUNAR HIGHLANDS": "CLAVIUS-KRATER · MONDHOCHLAND",
  "COLIMA": "COLIMA",
  "CONNAUGHT PLACE": "CONNAUGHT PLACE",
  "CONSELL DE CENT": "CONSELL DE CENT",
  "COPERNICUS": "KOPERNIKUS",
  "CORNICHE EL NIL": "CORNICHE EL NIL",
  "CRATER PARK": "KRATERPARK",
  "Cairo Citadel": "Zitadelle von Kairo",
  "Cairo Tower": "Turm von Kairo",
  "Cannaregio": "Cannaregio",
  "Canyon campus": "Campus Canyon",
  "Casa Batlló": "Haus Batlló",
  "Casa Milà": "Haus Milà",
  "Ca’ d’Oro": "Ca' d'Oro",
  "Central Gardens": "Zentrale Gärten",
  "Central Jakarta": "Zentral-Jakarta",
  "Central commons": "Zentrale Gemeingüter",
  "Central lagoon": "Zentrale Lagune",
  "Centro": "Centro",
  "Centro Histórico": "Centro Histórico",
  "Champ de Mars": "Champ de Mars",
  "Chaoyang CBD": "Chaoyang CBD",
  "Chapultepec Castle": "Schloss Chapultepec",
  "Clavius Spaceport": "Raumhafen Clavius",
  "Copernicus Research Center": "Copernicus-Forschungszentrum",
  "Coral Conservatory": "Korallenkonservatorium",
  "Cour Napoléon": "Cour Napoléon",
  "DAIKANYAMA": "DAIKANYAMA",
  "DARYAGANJ": "DARYAGANJ",
  "DASHILAN": "DASHILAN",
  "DECATUR BLVD": "DECATUR BOULEVARD",
  "DEPART": "ABREISEN",
  "DESERT PARK": "WÜSTENPARK",
  "DI’ANMEN": "DIANMEN",
  "DONCELES": "DONCELES",
  "DONGCHENG · CHAOYANG · OLYMPIC PARK": "DONGCHENG · CHAOYANG · OLYMPIAPARK",
  "DONGSI": "DONGSI",
  "DONGZHIMEN": "DONGZHIMEN",
  "DORSODURO": "DORSODURO",
  "DOWNTOWN · HISTORIC CAIRO · GIZA": "INNENSTADT · HISTORISCHES KAIRO · GIZEH",
  "DUMBO": "DUMBO",
  "DUNE PARK": "DÜNENPARK",
  "DURANGO DR": "DURANGO, DR.",
  "Dancheong palace eaves and intimate hanok lanes meet glass towers, design plazas and riverside paths.": "Die Traufen des Dancheong-Palastes und die intimen Hanok-Gassen treffen auf Glastürme, Designplätze und Uferwege.",
  "Desert Wheel": "Wüstenrad",
  "Doge’s Palace & Campanile": "Dogenpalast und Campanile",
  "Dolmabahçe Palace": "Dolmabahçe-Palast",
  "Domes and slender minarets rise above timber bay windows, red-tiled houses and bustling streets beside the Bosphorus.": "Kuppeln und schlanke Minarette erheben sich über hölzerne Erkerfenster, rote Ziegelhäuser und belebte Straßen am Bosporus.",
  "Dongdaemun": "Dongdaemun",
  "Dongdaemun Design Plaza": "Dongdaemun Design Plaza",
  "Dorsoduro": "Dorsoduro",
  "Downtown Las Vegas": "Innenstadt von Las Vegas",
  "DİVANYOLU": "DIVANYOLU",
  "EARTHRISE": "ERDAUFGANG",
  "EAST SIDE": "OSTSEITE",
  "EIXAMPLE · GRÀCIA · CIUTAT VELLA": "EIXAMPLE · GRACIA · CIUTAT VELLA",
  "ELYSIUM MONS": "ELYSIUM MONDE",
  "ENGLISH GARDEN": "ENGLISCHER GARTEN",
  "ERATOSTHENES": "ERATOSTHENE",
  "EUDOXUS": "EUDOXUS",
  "EULJI RO": "EULJI ODER",
  "East River · Brooklyn": "East River · Brooklyn",
  "Edifício Copan": "Edifício Copan",
  "Egyptian Museum": "Ägyptisches Museum",
  "Eiffel Tower": "Eiffelturm",
  "Eixample": "Eixample",
  "Elysium Biogardens": "Elysium Biogärten",
  "Energy quarter": "Energieviertel",
  "Entertainment district": "Unterhaltungsviertel",
  "FAROE BANK": "FÄRÖER BANK",
  "FAUBOURG HONORÉ": "FAUBOURG HONORÉ",
  "FEROZ SHAH ROAD": "FEROZ SHAH ROAD",
  "FESTIVAL": "FESTIVAL",
  "FIESTA": "FIESTA",
  "FLAMINGO RD": "FLAMINGO ROT",
  "FLATIRON": "FLATIRON",
  "FONDAMENTA ORMESINI": "FONDAMENTA ORMESINI",
  "FORT APACHE": "FORT APACHE",
  "FRANCISCO SOSA": "FRANCISCO SOSA",
  "FREMONT ST": "FREMONT STREET",
  "FUCHENGMEN": "FUCHENGMÄNNER",
  "Fatahillah Square": "Fatahillah-Platz",
  "Forbidden City": "Verbotene Stadt",
  "Fountain district": "Bezirk Fountain",
  "Frauenkirche": "Frauenkirche",
  "Fremont Lights": "Lichter von Fremont",
  "From Reforma and the historic center to Chapultepec’s gardens and Xochimilco’s canals.": "Von Reforma und dem historischen Zentrum bis zu den Gärten von Chapultepec und den Kanälen von Xochimilco.",
  "FÊTE DE PARIS": "FÊTE DE PARIS",
  "GALE CRATER": "STURMKRATER",
  "GALİP DEDE": "GALİP DEDE",
  "GAMALIYA": "GAMALIYA",
  "GANGNAM DAERO": "GANGNAM DAERO",
  "GAROSU GIL": "GAROSU-MÄDCHEN",
  "GASSENDI": "GASSENDI",
  "GIARDINI": "GIARDINI",
  "GINZA CHUO DORI": "GINZA CHUO DORI",
  "GOGOLEVSKY BLVD": "GOGOLEVSKY BOULEVARD",
  "GONGTI NORTH RD": "GONGTI NORTH ROAD",
  "GORKY PARK": "GORKI-PARK",
  "GRAMERCY": "GRAMERCY",
  "GRAN DE GRÀCIA": "GRAN DE GRACIA",
  "GRAND BANKS": "GROSSBANKEN",
  "GREENPOINT": "GREENPOINT",
  "GUIJIE": "GUIJIE",
  "GULF STREAM": "GOLFSTROM",
  "GUM Arcade": "GUM Arcade",
  "GUOMAO": "GUOMAO",
  "GUSEV CRATER": "GUSEV-KRATER",
  "Galata Tower": "Galataturm",
  "Garden district": "Gartenbezirk",
  "Geunjeongjeon Hall": "Geunjeongjeon-Halle",
  "Gezira": "Gezira",
  "Giza Pyramids": "Pyramiden von Gizeh",
  "Giza plateau": "Gizeh-Plateau",
  "Golden Crescent": "Goldener Halbmond",
  "Golden Monas, tiled Kota Tua streets and breezy Betawi verandas set against the towers of Sudirman.": "Goldene Monas, geflieste Straßen von Kota Tua und luftige Betawi-Veranden vor den Türmen von Sudirman.",
  "Golden palace roofs, quiet hutong courtyards and a modern skyline beyond the imperial gardens.": "Goldene Palastdächer, ruhige Hutong-Innenhöfe und eine moderne Skyline hinter den kaiserlichen Gärten.",
  "Grand Canal": "Canal Grande",
  "Gràcia": "Gracia",
  "Gyeongbokgung Palace": "Gyeongbokgung-Palast",
  "GÄRTNERPLATZ": "GÄRTNERPLATZ",
  "GÜLHANE PARK": "GÜLHANE PARK",
  "HANNAM DAERO": "HANNAM DAERO",
  "HARBOR": "HAFEN",
  "HARLEM": "HARLEM",
  "HARMON AVE": "HARMON-HÖHLE",
  "HARUMI DORI": "HARUMI DORI",
  "HELLAS PLANITIA": "HELLAS PLANITIA",
  "HOBYAR": "HOBYAR",
  "HODA SHAARAWI": "HODA SHAARAWI",
  "HOFGARTEN": "HOFGARTEN",
  "HOMERO": "HOMERO",
  "HONGIK RO": "HONGIO-RO",
  "HORACIO": "HORACIO",
  "HOÀN KIẾM": "HOÀN KIẾM",
  "HOÀN KIẾM · VĂN MIẾU · BA ĐÌNH": "HOÀN KIẾM · VĂN MIẾU · BA ĐÌNH",
  "HOÀNG DIỆU": "HOÀNG DIỆU",
  "HUMAYUN ROAD": "HUMAYUN-STRASSE",
  "Hagia Sophia": "Hagia Sophia",
  "Hall of Supreme Harmony": "Halle der Höchsten Harmonie",
  "Hanoi Opera House": "Opernhaus Hanoi",
  "Harbor Beacon": "Hafensignal",
  "Highland research quarter": "Forschungsviertel Highland",
  "Historic Cairo": "Historisches Kairo",
  "Hoàn Kiếm Lake": "Hoàn-Kiếm-See",
  "Humayun’s Tomb": "Humayuns Grab",
  "HÀNG BUỒM": "HÀNG BUỘM",
  "HÀNG BẠC": "HÀNG BÁC",
  "HÀNG GAI": "HANG GAI",
  "HÀNG MÃ": "HÀNG MÃ",
  "HÀNG ĐÀO": "HÀNG ĐÀO",
  "IBIRAPUERA": "IBIRAPUERA",
  "IKSEON DONG": "IKSEON DONG",
  "IMBRIUM": "IMBRIUM",
  "INSADONG GIL": "VERRÜCKTES MÄDCHEN",
  "INSURGENTES": "AUFSTÄNDISCHE",
  "IRISH SEA": "IRISCHE SEE",
  "ISARTORPLATZ": "ISARTORPLATZ",
  "ISIDIS PLANITIA": "ISIDIS PLANITIA",
  "ISMAIL MOHAMED": "ISMAIL MOHAMED",
  "ITAEWON RO": "ITAEWON ODER",
  "Ibirapuera Auditorium": "Auditorium Ibirapuera",
  "Ibirapuera Park": "Parque Ibirapuera",
  "India Gate": "Indisches Tor",
  "Istiqlal Mosque": "Istiqlal-Moschee",
  "JALAN CIKINI": "JALAN CIKINI",
  "JALAN DIPONEGORO": "JALAN DIPONEGORO",
  "JALAN GAJAH MADA": "JALAN GAJAH MADA",
  "JALAN GATOT SUBROTO": "JALAN GATOT SUBROTO",
  "JALAN GLODOK": "JALAN GLODOK",
  "JALAN HAYAM WURUK": "JALAN HAYAM WURUK",
  "JALAN JUANDA": "JALAN JUANDA",
  "JALAN KALI BESAR": "JALAN KALI BESAR",
  "JALAN KEBON SIRIH": "JALAN KEBON SIRIH",
  "JALAN KEMANG RAYA": "JALAN KEMANG RAYA",
  "JALAN MAJAPAHIT": "JALAN MAJAPAHIT",
  "JALAN MENTENG": "JALAN MENTENG",
  "JALAN PANCORAN": "JALAN PANCORAN",
  "JALAN PINTU BESAR": "JALAN PINTU BESAR",
  "JALAN RASUNA SAID": "JALAN RASUNA SAGTE",
  "JALAN SABANG": "JALAN SABANG",
  "JALAN SENOPATI": "JALAN SENOPATI",
  "JALAN SUDIRMAN": "JALAN SUDIRMAN",
  "JALAN THAMRIN": "JALAN THAMRIN",
  "JALAN VETERAN": "JALAN VETERAN",
  "JALAN WAHID HASYIM": "JALAN WAHID HASYIM",
  "JANPATH": "JANPATH",
  "JEZERO CRATER": "JEZERO-KRATER",
  "JIANGUOMEN": "JIANGUOMEN",
  "JINBAO ST": "JINBAO-STRASSE",
  "JINGSHAN PARK": "JINGSHAN-PARK",
  "JINGSHAN ST": "JINGSHAN-STRASSE",
  "JONGNO": "JONGNO",
  "JONGNO · NAMSAN · GANGNAM": "JONGNO · NAMSAN · GANGNAM",
  "JUÁREZ": "JUAREZ",
  "Jakarta History Museum": "Geschichtsmuseum von Jakarta",
  "Jamsil": "Jamsil",
  "KAGURAZAKA": "KAGURAZAKA",
  "KANDA": "KANDA",
  "KAPPABASHI": "KAPPABASHI",
  "KAROLINENPLATZ": "KAROLINENPLATZ",
  "KARTAVYA PATH": "KARTAVYA-PFAD",
  "KASTURBA GANDHI": "KASTURBA GANDHI",
  "KAUFINGERSTRASSE": "KAUFINGERSTRASSE",
  "KEMANKEŞ": "KEMANKEŞ",
  "KEPLER": "KEPLER",
  "KHAN EL KHALILI": "KHAN EL KHALILI",
  "KHAN MARKET": "KHAN-MARKT",
  "KILIÇ ALİ PAŞA": "KILIÇ ALİPAŞA",
  "KIM MÃ": "KIM MÃ",
  "KOVAL LN": "KOVAL AUF",
  "KURAMAE": "KURAMAE",
  "KUZNETSKY MOST": "KUZNETSKY MOST",
  "Kartavya Path": "Kartavya-Weg",
  "Khan el-Khalili": "Khan el-Khalili",
  "Kitay-Gorod": "Kitai-Gorod",
  "Kremlin walls": "Mauern des Kremls",
  "Kunming Lake": "Kunming-See",
  "KÖNIGSPLATZ": "KÖNIGSPLATZ",
  "LA RAMBLA": "LA RAMBLA",
  "LABRADOR SEA": "LABRADOR-MEER",
  "LANGRENUS": "LANGRENUS",
  "LANTERN FESTIVAL": "LATERNENFEST",
  "LAS VEGAS BLVD": "LAS VEGAS BOULEVARD",
  "LENBACHPLATZ": "LENBACHPLATZ",
  "LENOX HILL": "LENOX HILL",
  "LEOPOLDSTRASSE": "LEOPOLDSTRASSE",
  "LIULICHANG": "LIULICHANG",
  "LIỄU GIAI": "LIỄU GIAI",
  "LODHI GARDEN": "LODHI-GARTEN",
  "LODHI ROAD": "LODHI-STRASSE",
  "LUDWIGSTRASSE": "LUDWIGSTRASSE",
  "LUXEMBOURG": "LUXEMBURG",
  "La Pedrera": "La Pedrera",
  "Las Vegas Boulevard": "Las Vegas Boulevard",
  "Long Biên Bridge": "Long Biên Brücke",
  "Lotte Center Hanoi": "Lotte Center Hanoi",
  "Lotte World Tower": "Lotte World Tower",
  "Lotus Temple": "Lotus-Tempel",
  "Louvre Palace": "Louvre-Palast",
  "Lunar Council Spire": "Turm des Mondrats",
  "LÝ QUỐC SƯ": "LÝ QUỚC S",
  "LÝ THÁI TỔ": "LÝ THÁI T",
  "LƯƠNG VĂN CAN": "LƯƠNG VĂN CAN",
  "MADEIRA": "MADEIRA",
  "MADERO": "MADERO",
  "MAHMUTPAŞA": "MAHMUTPAŞA",
  "MAIN ST": "HAUPTSTRASSE",
  "MANEZHNAYA": "MANEZHNAYA",
  "MANSOUR STREET": "MANSOUR STRASSE",
  "MARIENPLATZ": "MARIENPLATZ",
  "MAROSEYKA": "MAROSEYKA",
  "MARUNOUCHI": "MARUNOUCHI",
  "MASARYK": "MASARYK",
  "MASP": "KARTEN",
  "MATHURA ROAD": "MATHURA-STRASSE",
  "MAX-JOSEPH-PLATZ": "MAX-JOSEPH-PLATZ",
  "MAXIMILIANSTR": "MAXIMILIANSTR.",
  "MEDAN MERDEKA": "MEDAN MERDEKA",
  "MEHRAULI ROAD": "MEHRAULI-STRASSE",
  "MEIJI DORI": "MEIJI DORI",
  "MERCERIE": "MERCERIE",
  "MERDEKA · KOTA TUA · SUDIRMAN": "MERDEKA · TUA TUA · SUDIRMAN",
  "MERIDIANI": "MERIDIANI",
  "METRO": "U-BAHN",
  "METRÔ": "METRÔ",
  "MICHOACÁN": "MICHOACÁN",
  "MID ATLANTIC RIDGE": "MITTELATLANTISCHER KAMM",
  "MIDTOWN": "MIDTOWN",
  "MOHAMED MAHMOUD": "MOHAMED MAHMOUD",
  "MONEDA": "MONEDA",
  "MONORAIL": "EINSCHIENENBAHN",
  "MORETUS": "MORETUS",
  "MRT": "MRT",
  "MURRAY HILL": "MURRAY HILL",
  "MYASNITSKAYA": "MYASNITSKAYA",
  "MYEONGDONG GIL": "MYEONGDONG GIL",
  "Maiden’s Tower": "Jungfrauenturm",
  "Marienplatz": "Marienplatz",
  "Marunouchi": "Marunouchi",
  "Mehrauli": "Mehrauli",
  "Merdeka Square": "Merdeka-Platz",
  "Metropolitan Government Building": "Regierungsgebäude der Metropolregion",
  "Midtown Manhattan": "Midtown Manhattan",
  "Mokattam": "Mokattam",
  "Montmartre": "Montmartre",
  "Moskva embankment": "Moskwa-Damm",
  "MÃ MÂY": "MÃ MÂY",
  "MÉTRO": "U-BAHN",
  "N Seoul Tower": "N Seoul-Turm",
  "NAKAMISE DORI": "NAKAMISE DORI",
  "NAMSAN PARK": "NAMSAN PARK",
  "NANLUOGUXIANG": "NANLUOGUXIANG",
  "NATIVITAS": "WEIHNACHTSKRIPPEN",
  "NELSON MANDELA": "NELSON MANDELA",
  "NEON FESTIVAL": "NEONFESTIVAL",
  "NEUHAUSER STR": "NEUHAUSER STRASSE",
  "NGÔ QUYỀN": "NGÔ QUYẾN",
  "NHÀ THỜ": "NHÀ TH",
  "NIHONBASHI": "NIHONBASHI",
  "NIKITSKY BLVD": "NIKITSKY BOULEVARD",
  "NILE FESTIVAL": "NILFEST",
  "NINGYOCHO": "NINGYOCHO",
  "NOCTIS LABYRINTHUS": "NOCTIS LABYRINTHUS",
  "NOLITA": "NOLITA",
  "NURUOSMANİYE": "NURUOSMANIYE",
  "Namdaemun": "Namdaemun",
  "Namsan Hill": "Namsan-Hügel",
  "National Monument": "Nationaldenkmal",
  "National Stadium": "Nationalstadion",
  "Neuhausen-Nymphenburg": "Neuhausen-Nymphenburg",
  "New Town Hall": "Neues Rathaus",
  "New York Harbor": "Hafen von New York",
  "Nizamuddin": "Nizamuddin",
  "Notre-Dame": "Notre-Dame",
  "Nymphenburg Palace": "Schloss Nymphenburg",
  "OCEAN OF STORMS": "MEER DER STÜRME",
  "ODEONSPLATZ": "ODEONSPLATZ",
  "OGDEN AVE": "HOGDEN-HÖHLE",
  "OLYMPIC RO": "OLYMPIC RO",
  "OLYMPUS MONS": "OLYMPUS MONS",
  "OMOTESANDO": "OMOTESANDO",
  "ORDYNKA": "ORDYNKA",
  "ORIZABA": "ORIZABA",
  "OSTOZHENKA": "OSTOSCHENKA",
  "Oasis Palace": "Oasis-Palast",
  "Ocean gateway": "Tor zum Meer",
  "Oceanic Archive": "Ozeanisches Archiv",
  "Ochre shop houses, shaded courtyards and tiled temple roofs surround a lake, an iron bridge and a rising glass skyline.": "Ockerfarbene Ladenhäuser, schattige Innenhöfe und geflieste Tempeldächer umgeben einen See, eine Eisenbrücke und eine aufragende gläserne Skyline.",
  "Octávio Frias Bridge": "Octávio-Frias-Brücke",
  "Olympiapark": "Olympiapark",
  "Olympic Park": "Olympiapark",
  "Olympic Tower": "Olympiaturm",
  "Olympus Solar Tower": "Olympus Solarturm",
  "Ornate onion domes, red-brick towers and grand boulevards beside the Moskva River.": "Prunkvolle Zwiebeltürme, rote Backsteintürme und große Boulevards am Fluss Moskwa.",
  "Outside the dome · Landing apron": "Vor der Kuppel · Landevorfeld",
  "Outside the dome · Spaceflight district": "Außerhalb der Kuppel · Spaceflight District",
  "PARADISE RD": "PARADIESISCH ROT",
  "PARK AVENUE": "PARKALLEE",
  "PASEO REFORMA": "PASEO REFORMA",
  "PASSEIG COLOM": "PASSEIG COLOM",
  "PASSEIG DE GRÀCIA": "PASSEIG DE GRACIA",
  "PASSEIG DEL BORN": "PASSEIG DEL BORN",
  "PASSEIG SANT JOAN": "PASSEIG SANT JOAN",
  "PAULISTA · CENTRO · IBIRAPUERA": "PAULISTA · ZENTRUM · IBIRAPUERA",
  "PAVONIS MONS": "PAVONIS MONS",
  "PETAVIUS": "PETAVIUS",
  "PETRITXOL": "PETRITXOL",
  "PETROVKA": "PETROWKA",
  "PHAN ĐÌNH PHÙNG": "PHAN ĐÌNH PHUNNG",
  "PIAZZA SAN MARCO": "MARKUSPLATZ",
  "PICARD": "PICARD",
  "PLACE VENDÔME": "PLACE VENDÔME",
  "PLATO": "PLATO",
  "POKROVKA": "POKROVKA",
  "PORTAFERRISSA": "PORTAFERRISSA",
  "POSTCARD": "POSTKARTE",
  "PRECHISTENKA": "PRECHISTENKA",
  "PRINZREGENTENSTR": "PRINZREGENTENSTR.",
  "PROMENADEPLATZ": "PROMENADEPLATZ",
  "PUERTO RICO TRENCH": "GRABEN VON PUERTO RICO",
  "PUNTA DELLA DOGANA": "PUNTA DELLA DOGANA",
  "PYATNITSKAYA": "PYATNITSKAYA",
  "Palace of the Tides": "Der Palast der Gezeiten",
  "Park Güell": "Park Güell",
  "Paseo de la Reforma": "Paseo de la Reforma",
  "Passeig de Gràcia": "Passeig de Gracia",
  "Passeig de Lluís Companys": "Passeig de Lluís Companys",
  "Past copper domes and painted façades, through Bavarian squares and the green banks of the Isar.": "Vorbei an Kupferkuppeln und bemalten Fassaden, durch bayerische Plätze und das grüne Isarufer.",
  "Pearl Citadel": "Perlenzitadelle",
  "Piazza San Marco": "Markusplatz",
  "Pinheiros River": "Rio Pinheiros",
  "Plaza de la Constitución": "Plaza de la Constitución",
  "Poseidon Lighthouse": "Leuchtturm von Poseidon",
  "Praça da Sé": "Praça da Sé",
  "Prism Sphere": "Prismenkugel",
  "QASR EL AINI": "QASR EL AINI",
  "QASR EL NIL": "QASR EL NIL",
  "QIANMEN ST": "QIANMEN-STRASSE",
  "QUAI VOLTAIRE": "QUAI VOLTAIRE",
  "QUỐC TỬ GIÁM": "QUỚC TGIÁM",
  "Qutub Minar": "Qutb Minar",
  "RAIL": "SCHIENE",
  "RAINBOW BLVD": "REGENBOGEN-BOULEVARD",
  "RAMBLA CATALUNYA": "RAMBLA CATALUNYA",
  "RED HOOK": "ROTER HAKEN",
  "RED ROCK": "ROTER FELSEN",
  "RED SQUARE · TVERSKOY · MOSKVA": "ROTER PLATZ · TVERSKOY · MOSKVA",
  "REEF PARK": "RIFFPARK",
  "REGINA": "REGINA",
  "RIALTO": "RIALTO",
  "RIO GRANDE RISE": "RIO GRANDE RISE",
  "RIVA DEGLI SCHIAVONI": "RIVA DEGLI SCHIAVONI",
  "RIVA DEL VIN": "RIVA DEL VIN",
  "RIVERSIDE": "FLUSSUFER",
  "ROCKALL": "ROCKALL",
  "ROMANCHE TRENCH": "ROMANCHE-TRENCHCOAT",
  "ROPPONGI": "ROPPONGI",
  "ROVER PORT": "ROVER-HAFEN",
  "RUA 25 DE MARÇO": "STRASSE 25 DE MARÇO",
  "RUA AUGUSTA": "RUA AUGUSTA",
  "RUA BOA VISTA": "RUA BOA VISTA",
  "RUA CONSOLAÇÃO": "RUA CONSOLAÇÃO",
  "RUA DA MOOCA": "RUA DA MOOCA",
  "RUA DOMINGOS MORAIS": "RUA DOMINGOS MORAIS",
  "RUA DOS TRILHOS": "RUA DOS TRILHOS",
  "RUA FRADIQUE COUTINHO": "RUA FRADIQUE COUTINHO",
  "RUA FREI CANECA": "RUA FREI CANECA",
  "RUA HARMONIA": "RUA HARMONIA",
  "RUA LIBERO BADARÓ": "RUA LIBERO BADARÓ",
  "RUA OSCAR FREIRE": "STRASSE OSCAR FREIRE",
  "RUA TABAPUÃ": "RUA TABAPUÃ",
  "RUA TEODORO SAMPAIO": "RUA TEODORO SAMPAIO",
  "RUA VERGUEIRO": "RUA VERGUEIRO",
  "RUE CLER": "WAHR KLAR",
  "RUE DE BUCI": "RUE DE BUCI",
  "RUE DE PASSY": "RUE DE PASSY",
  "RUE DE RENNES": "RUE DE RENNES",
  "RUE DE RIVOLI": "RUE DE RIVOLI",
  "RUE DES MARTYRS": "RUE DES MARTYRS",
  "RUE MONTORGUEIL": "RUE MONTORGUEIL",
  "RUE MOUFFETARD": "RUE MOUFFETARD",
  "RUE SAINT-HONORÉ": "RUE SAINT-HONORÉ",
  "RUSSELL RD": "RUSSELL ROAD",
  "Raisina Hill": "Raisina Hill",
  "Rashtrapati Bhavan": "Rashtrapati Bhavan",
  "Red River": "Roter Fluss",
  "Red Square": "Roter Platz",
  "Reef gardens": "Riffgärten",
  "Reforma Tower": "Reforma-Turm",
  "Residenz & Hofgarten": "Residenz und Hofgarten",
  "Residenzviertel": "Residenzviertel",
  "Resort promenade": "Promenade des Resorts",
  "Rialto Bridge": "Rialto-Brücke",
  "Royal canal": "Königlicher Kanal",
  "SABRI ABU ALAM": "SABRI ABU ALAM",
  "SAHARA AVE": "SAHARA-HÖHLE",
  "SAINT-GERMAIN": "ST-GERMAIN",
  "SAINT-MICHEL": "ST. MICHEL",
  "SAMCHEONG RO": "SAMCHEONG ODER",
  "SAN CASSIANO": "SAN CASSIANO",
  "SAN LUCA": "SAN LUCA",
  "SAN MARCO · RIALTO · DORSODURO": "SAN MARCO · RIALTO · DORSODURO",
  "SAN STAE": "ZUSTAND SCANNEN",
  "SAN TROVASO": "SAN TROVASO",
  "SANLITUN": "SANLITUN",
  "SARGASSO SEA": "SARGASSOSEE",
  "SCHELLINGSTRASSE": "SCHELLINGSTRASSE",
  "SCHICKARD": "SCHICKARD",
  "SCHILLER": "SCHILLER",
  "SEJONG DAERO": "SEJONG DAERO",
  "SENDLINGER STR": "SENDLINGER STRASSE",
  "SEONGSU IL RO": "SEONGSU IL RO",
  "SERDAR I EKREM": "SERDAR I EKREM",
  "SERENITY": "GELASSENHEIT",
  "SHACKLETON": "SHACKLETON",
  "SHERIF STREET": "SHERIF STREET",
  "SHIBUYA": "SHIBUYA",
  "SHIELD": "SCHILD",
  "SHINJUKU DORI": "SHINJUKU DORI",
  "SINCHON RO": "SINCHON ODER",
  "SIRASELVİLER": "SIRASELVİLER",
  "SOFIYSKAYA QUAY": "SOFIYSKAYA-KAI",
  "SOHO": "SOHO",
  "SOL FESTIVAL": "SOL-FESTIVAL",
  "SOLARA BASIN · MARTIAN FRONTIER": "SOLARA-BECKEN · MARSGRENZE",
  "SOĞUKÇEŞME": "SOĞUKÇEŞME",
  "SPRING MTN RD": "FRÜHLING, MTN, ROT",
  "SRETENKA": "SRETENKA",
  "SRI AUROBINDO": "SRI AUROBINDO",
  "STRADA NOVA": "STRADA NOVA",
  "SUBWAY": "U-BAHN",
  "SULTANAHMET · GALATA · BOSPHORUS": "SULTANAHMET · GALATA · BOSPORUS",
  "SUNDAR NAGAR": "SUNDAR NAGAR",
  "SUNSET RD": "SONNENUNTERGANG, ROT",
  "SURPRISE": "ÜBERRASCHUNG",
  "SYRTIS MAJOR": "SYRTIS MAJOR",
  "Sacré-Cœur": "Sacré-Cœur",
  "Sagrada Família": "Sagrada Família",
  "Saint Basil’s Cathedral": "Basilius-Kathedrale",
  "Saint Mark’s Basilica": "Markusdom",
  "San Marco waterfront": "Uferpromenade von San Marco",
  "Sandstone courtyards, screened balconies and a lively Nile waterfront beneath the pyramids, the Citadel and Cairo’s lattice tower.": "Innenhöfe aus Sandstein, abgeschirmte Balkone und ein lebendiges Nilufer unter den Pyramiden, der Zitadelle und dem Gitterturm von Kairo.",
  "Sandstone gateways, marble petals and garden tombs amid colonnades, leafy avenues and a modern Delhi skyline.": "Sandsteintore, Marmorblätter und Gartengräber inmitten von Kolonnaden, grünen Alleen und einer modernen Skyline von Delhi.",
  "Santa Maria della Salute": "Santa Maria della Salute",
  "Scholar quarter": "Stipendiatenviertel",
  "Science avenue": "Allee der Wissenschaft",
  "Sculpted stone, mosaic roofs and iron balconies line Eixample blocks, with Gaudí silhouettes and palm-lined Mediterranean promenades.": "Steinskulpturen, Mosaikdächer und Eisenbalkone säumen die Eixample-Blöcke mit Gaudí-Silhouetten und palmengesäumten Mittelmeerpromenaden.",
  "Sculptural concrete, red museum beams and a layered skyline above leafy Paulista avenues.": "Skulpturaler Beton, rote Museumsbalken und eine vielschichtige Skyline über den grünen Paulista-Alleen.",
  "Selamat Datang Monument": "Selamat Datang Denkmal",
  "Sensō-ji Temple": "Sensō-ji-Tempel",
  "Seven Sisters Tower": "Turm der Sieben Schwestern",
  "Shiba Park": "Parque Shiba",
  "Shinjuku": "Shinjuku",
  "Skyline Tower": "Skyline-Turm",
  "Solara Beacon": "Solara Beacon",
  "Spasskaya Tower": "Spasskaja-Turm",
  "Sudirman": "Sudirman",
  "Sultanahmet": "Sultanahmet",
  "Sultanahmet Square": "Sultanahmet-Platz",
  "Sumida": "Sumida",
  "Summer Palace": "Sommerpalast",
  "Sungnyemun Gate": "Sungnyemun-Tor",
  "São Paulo Cathedral": "Kathedrale von São Paulo",
  "TACUBA": "TACUBA",
  "TAKESHITA DORI": "TAKESHITA DORI",
  "TAL": "TAL",
  "TALAAT HARB": "TALAAT HARB",
  "TAMAN SUROPATI": "TAMAN SUROPATI",
  "TAMAULIPAS": "TAMAULIPAS",
  "TEATRALNAYA": "TEATRALNAJA",
  "TEES JANUARY MARG": "BÄUME JANUAR MÄRZ",
  "TEHERAN RO": "TEHERAN ODER",
  "TERRA SIRENUM": "TERRA SIRENUM",
  "TEŞVİKİYE": "TEŞVİKİYE",
  "THANH NIÊN": "THANH NIAN",
  "THERESIENSTRASSE": "THERESIENSTRASSE",
  "TIDE FESTIVAL": "TIDENFEST",
  "TOEGYE RO": "TOEGYE ODER",
  "TOLSTOY MARG": "TOLSTOI MARG",
  "TRAM": "STRASSENBAHN",
  "TRANQUILITY": "RUHE",
  "TRANSIT": "TRANSIT",
  "TRAVESSERA GRÀCIA": "TRAVESSERA GRACIA",
  "TRIBECA": "TRIBECA",
  "TROPICANA AVE": "TROPICANA-HÖHLE",
  "TRÀNG TIỀN": "TRÀNG TIẾN",
  "TUILERIES": "TUILERIEN",
  "TVERSKAYA": "TWERSKAJA",
  "TVERSKOY BLVD": "TVERSKOY BOULEVARD",
  "TYCHO": "TYCHO",
  "Tahrir Square": "Tahrir-Platz",
  "Temple gates and tiled machiya streets, red steel towers and luminous shopfronts beneath a layered skyline.": "Tempeltore und geflieste Machiya-Straßen, rote Stahltürme und leuchtende Ladenfronten unter einer vielschichtigen Skyline.",
  "Temple of Heaven": "Tempel des Himmels",
  "Temple of Literature": "Tempel der Literatur",
  "Terracotta habitats and solar towers rise beneath a glass canopy on the floor of a vast Martian crater, surrounded by rust-red ridges. Rovers and new neighbors share the avenues.": "Terrakotta-Lebensräume und Solartürme erheben sich unter einem Glasdach auf dem Boden eines riesigen Marskraters, der von rostroten Graten umgeben ist. Rover und neue Nachbarn teilen sich die Alleen.",
  "Theater District": "Theaterviertel",
  "Theatre Square": "Theaterplatz",
  "Tiantan Park": "Tiantan-Park",
  "Tokyo Skytree": "Skytree von Tokio",
  "Tokyo Station": "Bahnhof Tokio",
  "Tokyo Tower": "Tokio-Turm",
  "Tranquility Gardens": "Gärten der Ruhe",
  "Tràng Tiền": "Tràng Tiên",
  "Turtle Tower": "Schildkrötenturm",
  "Tycho Observatory": "Tycho-Observatorium",
  "TẠ HIỆN": "TA HIỆN",
  "U-BAHN": "U-BAHN",
  "UENO HIROKOJI": "BUENO HIROKOJI",
  "UENO PARK": "UENO-PARK",
  "UNIVERSIDAD": "UNIVERSIDAD",
  "UPTOWN": "UPTOWN",
  "UTOPIA PLANITIA": "UTOPIE PLANITIA",
  "Upper Manhattan": "Oberes Manhattan",
  "VALLES MARINERIS": "VALLES MARINERIS",
  "VAPORETTO": "VAPORETTO",
  "VIA LAIETANA": "ÜBER LAIETANA",
  "VIKTUALIENMARKT": "VIKTUALIENMARKT",
  "VILLAGE": "DORF",
  "Valles Research Arc": "Forschungsbogen Vals",
  "Văn Miếu": "Van Miếu",
  "WALVIS RIDGE": "WALVIS RIDGE",
  "WANGFUJING": "WANGFUJING",
  "WARM SPRINGS": "WARME QUELLEN",
  "WELCOME": "WILLKOMMEN",
  "WILLIAMSBURG": "WILLIAMSBURG",
  "Wisma 46": "Wisma 46",
  "XIDAN": "XIDAN",
  "XOCHIMILCO": "XOCHIMILCO",
  "Xochimilco Gardens": "Xochimilco-Gärten",
  "Xochimilco canals": "Kanäle von Xochimilco",
  "YAKIMANKA": "YAKIMANKA",
  "YANAKA GINZA": "YANAKA GINZA",
  "YANDAI XIEJIE": "YANDAI XIEJIE",
  "YEONNAM DONG": "YEONNAM DONG",
  "YEOUIDO": "YEOUIDO",
  "YEREBATAN": "YEREBATAN",
  "YONGDINGMEN": "YONGDINGMEN",
  "YORKVILLE": "YORKVILLE",
  "ZARYADYE": "ZARYADYE",
  "ZATTERE": "ZATTERE",
  "ZHONGGUANCUN": "ZHONGGUANCUN",
  "Zócalo Cathedral": "Kathedrale von Zócalo",
  "ÁLVARO OBREGÓN": "ALVARO OBREGON",
  "ÁMSTERDAM": "AMSTERDAM",
  "ÇADIRCILAR": "CADIRCILAR",
  "Étoile": "Etoile",
  "Île de la Cité": "Ile de la Cité",
  "ĐINH TIÊN HOÀNG": "ĐINH TIÊN HOÀNG",
  "ĐIỆN BIÊN PHỦ": "ĐIỆN BIÊN PHỦ",
  "ĐỒNG XUÂN": "ĐONG XUÂN",
  "İSTİKLAL": "İSTIKLAL"
}
